import { useState, useEffect, useContext } from 'react'
import axios from 'axios';
import { useFormik } from "formik"
import * as Yup from "yup"
import Select from 'react-select';
import ContextStates from '../../context/ContextStates';
import { Url } from '../Url';

import marker from "leaflet/src/images/marker.svg"

import L, { Icon } from "leaflet";
import { MapContainer, TileLayer, Popup, Marker, useMap } from 'react-leaflet'
import "leaflet/dist/leaflet.css"

const to6 = (v) => Number(v).toFixed(6); // redondeo lindo para mostrar
const myIcon = new Icon({ iconUrl: marker, iconSize: [32, 32] });


const FormCliente = () => {
    const [position, setPosition] = useState([-26.833018562210178, -65.20875863504794]);
    const [apellido, setApellido] = useState('');
    const [nombre, setNombre] = useState('');
    const [domicilio, setDomicilio] = useState('');
    const [telefono, setTelefono] = useState('');
    const [map, setMap] = useState(null);
    const [guardar, setGuardar] = useState(true);

    const [zonas, setZonas] = useState([]);
    const [zona, setZona] = useState(0);
    const [draftPos, setDraftPos] = useState(null); // { lat, lng } para el pin manual
    const [saving, setSaving] = useState(false);


    const { modify, setViewOpen, idUsuario, setModify } = useContext(ContextStates);

    const onMapClickToMovePin = (e) => {
        setDraftPos({ lat: e.latlng.lat, lng: e.latlng.lng });
    };

    const onDragEndPin = (e) => {
        const p = e.target.getLatLng();
        setDraftPos({ lat: p.lat, lng: p.lng });
    };

    // Zonas
    useEffect(() => {
        const consultaZonas = async () => {
            if (map) {
                const c = map.getCenter();
                setDraftPos({ lat: c.lat, lng: c.lng });
            } else {
                setDraftPos({ lat: position[0], lng: position[1] });
            }
            const formData = new FormData();
            formData.append("id", 1);
            formData.append("activo", 1);
            try {
                const response = await axios.post(Url + 'api/listZonas.php', formData);
                setZonas(response.data.results);
            } catch (e) {
                console.log(e);
            }
        };
        consultaZonas();
    }, [setZonas]);

    // Clientes



    // Simula guardar un "nuevo cliente" usando las coords del pin.
    const guardarNuevoCliente = async () => {
        if (!draftPos) return;
        if (guardar) {
            setGuardar(false)
            if (apellido !== '' && nombre !== '' && zona !== 0) {
                setSaving(true);
                try {
                    const formData = new FormData();
                    formData.append('apellido', apellido);
                    formData.append('nombre', nombre);
                    formData.append('domicilio', domicilio);
                    formData.append('telefono', telefono);
                    formData.append('lat', draftPos.lat);
                    formData.append('lon', draftPos.lng);
                    formData.append('zona', zona.id);
                    formData.append('idusuario', idUsuario);

                    const result = await axios.post(Url + 'api/clientesAlta.php', formData);
                    console.log(result)
                    let aux = modify + 1;
                    setModify(aux);

                    /*if (formPrev !== 0)
                        handleReturn();*/
                    // refresc�s listado
                } catch (err) {
                    console.error(err);
                    alert('No se pudo guardar el cliente.');
                } finally {
                    setViewOpen(false)
                    setSaving(false);
                }
            }
        }
    };


    return (
        <div className="mt-1 mb-10 w-full z-0">
            <h2 className='text-3xl uppercase mb-3 text-center'>Nuevo Cliente</h2>
            <div className='flex'>
                <div className="sm:items-start sm:w-1/2 w-full mr-2">
                    <label htmlFor="apellido" className="block mt-5 text-gray-600 uppercase font-bold">Apellido</label>
                    <input
                        className="py-2 px-3 w-full rounded bg-slate-300"
                        id="apellido"
                        placeholder="Ingrese el apellido"
                        type="text"
                        value={apellido}
                        onChange={(e) => setApellido(e.target.value)}
                        autoFocus
                    />
                </div>
                <div className="sm:items-start sm:w-1/2 w-full ml-2">
                    <label htmlFor="nombre" className="block mt-5 text-gray-600 uppercase font-bold">Nombre</label>
                    <input
                        className="py-2 px-3 w-full rounded bg-slate-300"
                        id="nombre"
                        placeholder="Ingrese el nombre"
                        type="text"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />
                </div>
            </div>
            <div className="sm:items-start mt-5">
                <label htmlFor="domicilio" className="block text-gray-600 uppercase font-bold">Domicilio</label>
                <input
                    className="py-2 px-3 w-full rounded bg-slate-300"
                    id="domicilio"
                    placeholder="Ingrese Domicilio"
                    type="text"
                    value={domicilio}
                    onChange={(e) => setDomicilio(e.target.value)}
                />
            </div>
            <div className="sm:items-start mt-5">
                <label htmlFor="telefono" className="block text-gray-600 uppercase font-bold">Nº de Teléfono</label>
                <input
                    className="py-2 px-3 w-full rounded bg-slate-300"
                    id="telefono"
                    placeholder="Ingrese Nº de Teléfono"
                    type="text"
                    value={telefono}
                    onChange={(e) => setTelefono(e.target.value)}
                />
            </div>
            <div className="w-1/2 mx-auto mt-5 mb-4">
                <Select
                    options={zonas}
                    placeholder="Seleccione la zona"
                    onChange={(value) => setZona(value)}
                    name='sZona'
                />
            </div>

            {/* --- NUEVO: panel compacto con coords cuando está activo el modo manual --- */}
            <div className="mx-auto mb-3 max-w-3xl rounded-lg border p-3 bg-emerald-50 text-emerald-900">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                    <div>
                        <strong>Ubicación seleccionada:</strong>{' '}
                        {(draftPos && draftPos.lat) && (
                            <p>
                                Lat: {to6(draftPos.lat)} | Lng: {to6(draftPos.lng)}
                            </p>

                        )}
                        <span className="ml-2 text-sm opacity-80">
                            (arrastrá el pin o hacé click en el mapa)
                        </span>
                    </div>
                    <div className="flex gap-2">
                        <button
                            onClick={guardarNuevoCliente}
                            disabled={saving}
                            className="px-4 py-2 rounded-md bg-emerald-600 text-white disabled:opacity-60"
                        >
                            {saving ? 'Guardando…' : 'Confirmar y guardar'}
                        </button>
                    </div>
                </div>
            </div>


            <MapContainer
                center={position}
                zoom={18}
                scrollWheelZoom
                className="mx-auto h-full z-0"
                whenCreated={(m) => setMap(m)}
                style={{ maxWidth: '80vw', height: 800, cursor: 'crosshair' }}
                // --- NUEVO: click para mover el pin ---
                eventHandlers={{ click: onMapClickToMovePin }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {/* --- NUEVO: marcador DRAGGABLE para el alta manual --- */}
                {(draftPos && draftPos.lat) && (
                    <Marker
                        position={[draftPos.lat, draftPos.lng]}
                        draggable={true}
                        icon={myIcon} // o el que prefieras
                        eventHandlers={{ dragend: onDragEndPin }}
                    >
                        <Popup autoClose={false} closeOnClick={false}>
                            <div className="text-sm">
                                <div><strong>Lat:</strong> {to6(draftPos.lat)}</div>
                                <div><strong>Lng:</strong> {to6(draftPos.lng)}</div>
                                <div className="mt-2 opacity-80">
                                    Arrastrá el pin o hacé click en el mapa para reubicar.
                                </div>
                            </div>
                        </Popup>
                    </Marker>
                )}
            </MapContainer>
        </div>
    );
}

export default FormCliente
